<template lang="pug">
	.project-version-preview-list(v-if="showed && Version.SelectedVersion && Project.SelectedProject")
		.card
			.card-header
				i.fa.fa-edit
				span Project Version Previews List
			.card-body.collapse.show
				.existing-previews
					.existing-preview(v-for="preview in previews")
						.date {{preview.createDate.toLocaleString()}}
						.link(v-on:click="open(preview)") {{preview['hash']}}
						.delete-button(v-on:click="deletePreview(preview)")
							i.fa.fa-remove
				.form-actions
					button.btn.btn-primary(type="submit" v-on:click="createNew()") Create new preview
					button.btn.btn-ghost-dark(type="button" v-on:click="hide()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen';

	import { Project } 			from './../../services/Project';
	import { Version } 			from './../../services/Version';
	import { Settings } 		from './../../services/Settings';

	import _ 					from 'lodash';

	import SetupSettings		from "./../../settings/settings";

	export default {
		name: "ProjectVersionPreviewList",
		mixins: [Screen],
		screen: {
			updateOn: ["Project Version Previews Changed"]
		},
		data() {

			this.Project = Project;
			this.Version = Version;
			this.Settings = Settings;

			this.previews = [];

			return {
				showed: false
			}
		},
		methods: {
			collectData() {

				if (Version.VersionPreviewsByVersionByHash) {

					this.previews = _.orderBy(_.values(Version.VersionPreviewsByVersionByHash[Version.SelectedVersion?.id]) || [], 'createDate', 'desc');

				} else {

					this.previews = [];

				}

			},
			open(preview) {

				Broadcast.call("Preview Link Pressed");

				if (SetupSettings["dev"]) window.open(`${location.protocol}//${SetupSettings["domain"]}:${(location.protocol === "https:" ? SetupSettings["portSSL"] : SetupSettings["port"])}/preview/${preview.hash}/`, "_blank");
				// else window.open(`https://creative-preview.cc/preview/${preview.hash}/`, "_blank");
				else window.open(`https://${SetupSettings.previewHost}/preview/${preview.hash}/`, "_blank");

			},
			createNew() {

				Broadcast.call("Show ProjectVersionPreviewCreate");

				this.hide();

			},
			deletePreview(preview) {

				Broadcast.call("Show ProjectVersionPreviewDelete", [preview]);

			}
		}
	}
</script>


<style lang="sass">

	.project-version-preview-list
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 245px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			input
				width: 460px
				margin-top: 5px

			.btn-ghost-dark
				float: right
				color: #fff

			.existing-previews
				background-color: #343b41
				border: 1px solid #23282c
				border-radius: 5px
				height: 100px
				overflow-x: hidden
				overflow-y: auto

				.existing-preview
					display: flex
					height: 30px
					padding: 0 1rem
					align-items: center
					justify-content: space-between

					&:hover
						background-color: #4c4f54

					.date
						cursor: default

					.link
						cursor: pointer

						&:hover
							text-decoration: underline

					.delete-button
						cursor: pointer

						&:hover
							color: #d16767

			.form-horizontal
				display: flex
				flex-direction: column

				.form-group
					display: flex
					flex-direction: row
					justify-content: space-between
					align-items: center

			.form-actions
				margin-top: 1.25rem

		.switch-slider
			background-color: #343b41
			border: 1px solid #23282c

</style>

